import { Component, Input, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { ApplicationService } from '@app/core/services/application/application.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-complete',
    templateUrl: './application-complete.component.html',
    styleUrls: ['./application-complete.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ApplicationCompleteComponent implements OnInit {
    @Input() status: any;
    content: any = {};

    constructor(
        private applicationService: ApplicationService,
        public toolService: ToolService
    ) {}

    ngOnInit() {
        this.toolService.content.subscribe((content: any) => {
            this.content = content;
        });
    }

    downloadCertificate() {
        // console.log("download cert");
        // this.angulartics2GoogleTagManager.eventTrack('Certificate of Completion downloaded', { category: 'Application' });
        this.applicationService
            .downloadCertificationOfCompletion(
                this.status.application.id,
                this.status.application.userid
            )
            .subscribe((certificate: any) => {
                window.open(certificate.redirect, '_blank');
            });
    }

    toInstagram = () => {
        window.open(this.content.basic.url.instagram, '_blank');
    };
    toFacebook() {
        window.open(this.content.basic.url.facebook, '_blank');
    }
}
